import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const StepFive = ({ styles, onSubmit, detail }) => {
    return (
        <React.Fragment>
            <div>
                <div className='row justify-content-center'>
                    <div className='col-md-10'>
                        <h1 className={`${styles['main-title']} text-center mt-2`}>Choose a Job that fits your need for hiring</h1>
                        <p className={`${styles['main-para']} text-center text-muted mb-5`}>Get more qualified candidates for your team</p>
                        <div className="row justify-content-center g-4">
                            {/* Regular Plan */}
                            <div className="col-md-4">
                                <div className="pricing-plan border rounded p-4">
                                    <h3 className={`${styles['ctjob-title']}`}>Regular Job</h3>
                                    <p className={`${styles['ctjob-para']} mb-4`}>Best suited for 1 hire</p>
                                    <p className={`${styles['ctjob-cost']} mb-4`}>&#8377;Free<span className={`${styles['normal-text']}`}></span></p>
                                    <button className={`${styles['btn-next']} w-100 btn`}
                                        onClick={() => {
                                            onSubmit({ JOB_ID: detail.JOB_ID, LISTNING_TYPE: '1' })
                                        }}
                                    >Get Started</button>
                                    <p className={`${styles['ctjob-heading']} mt-4`}>What your get:</p>
                                    <ul className={`${styles['ctjob-list']}`}>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Smart Boost via Whatsapp</li>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Higher visibility to candidates</li>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Urgently Hiring Tag</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Featured Plan */}
                            <div className="col-md-4">
                                <div className="pricing-plan border rounded p-4">
                                    <h3 className={`${styles['ctjob-title']}`}>Featured Job</h3>
                                    <p className={`${styles['ctjob-para']} mb-4`}>Best suited for 2 hires</p>
                                    <p className={`${styles['ctjob-cost']} mb-4`}>&#8377;299<span className="fs-6 fw-normal">/month</span></p>
                                    <button className={`${styles['btn-next']} w-100 btn`}
                                        onClick={() => {
                                            onSubmit({ JOB_ID: detail.JOB_ID, LISTNING_TYPE: '2' })
                                        }}
                                    >Get Started</button>
                                    <p className={`${styles['ctjob-heading']} mt-4`}>What your get:</p>
                                    <ul className={`${styles['ctjob-list']}`}>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Smart Boost via Whatsapp</li>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Higher visibility to candidates</li>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Urgently Hiring Tag</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Business Plan */}
                            <div className="col-md-4">
                                <div className="pricing-plan border rounded p-4 position-relative most-popular">
                                    <h3 className={`${styles['ctjob-title']}`}>Business</h3>
                                    <p className={`${styles['ctjob-para']} mb-4`}>Best suited for 4 hires</p>
                                    <p className={`${styles['ctjob-cost']} mb-4`}>&#8377;399<span className="fs-6 fw-normal">/month</span></p>
                                    <button className={`${styles['btn-next']} w-100 btn`}
                                        onClick={() => {
                                            onSubmit({ JOB_ID: detail.JOB_ID, LISTNING_TYPE: '3' })
                                        }}
                                    >Get Started</button>
                                    <p className={`${styles['ctjob-heading']} mt-4`}>What your get:</p>
                                    <ul className={`${styles['ctjob-list']}`}>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />2x Smart Boost via Whatsapp</li>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />2x Higher visibility to candidates</li>
                                        <li><FontAwesomeIcon className={`${styles['icon-blue']} pe-2`} icon={faCheck} />Urgently Hiring Tag</li>
                                    </ul>
                                    <span className={`${styles['most-popular-badge']}`}>Most Popular ✨</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-10'>
                        <div className="d-flex justify-content-between mt-4">
                            <button
                                className="btn btn-secondary"
                                disabled

                            >
                                Previous
                            </button>
                            <button
                                className={`${styles['btn-next']} btn`}


                            >
                                Post
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default StepFive